import { IMPERSONATION_BANNER_CLOSED_KEY } from '@/components/ImpersonatingBanner/constants'
import { authService } from '@/services/api/auth.service'
import { isPublicEndpoint } from '@/utils/functions/endpoints/publicEndpoints'
import axios from 'axios'

export const v1BaseURL = 'https://app.marqii.com/api/v1'
export const v2BaseURL = 'https://app.marqii.com/api/v2'

export const api = axios.create({
  baseURL: v1BaseURL,
  paramsSerializer: {
    indexes: null,
  },
})

api.interceptors.request.use(
  async (config) => {
    const session = await authService.fetchAuthSession()
    const accessToken = session.tokens?.accessToken?.toString()

    if (accessToken && config.headers) {
      config.headers.Authorization = `Bearer ${accessToken}`
    } else if (config.url && !isPublicEndpoint(config.url)) {
      await authService.signOut()
      localStorage.removeItem(IMPERSONATION_BANNER_CLOSED_KEY)
      window.location.assign('/')
    }
    return config
  },
  (error) => Promise.reject(new Error(error)),
)

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response } = error
    if (response?.status === 401) {
      await authService.signOut()
      localStorage.removeItem(IMPERSONATION_BANNER_CLOSED_KEY)
      window.location.assign('/')
      return
    }
    return Promise.reject(new Error(error))
  },
)
